import Page from '#globalComponents/Page/Page';

import PageHeader from '../../../../globalComponents/PageHeader/PageHeader';
import { TabNavigation } from '../../components/TabNavigation/TabNavigation';

const SettingsPage = () => {
	return (
		<Page
			header={
				<PageHeader
					title="Einstellungen"
					subtitle="Konto & Organisation verwalten"
					breadcrumbs={['Einstellungen']}
				/>
			}
		>
			<TabNavigation />
		</Page>
	);
};

export default SettingsPage;
